<template>
  <div class="">
    <select class="custom-select" @change="changeValueEvent">
      <option value="" v-t="`filter.product_status.all`"></option>
      <option value="1" v-t="`filter.product_status.publish`"></option>
      <option value="2" v-t="`filter.product_status.draft`"></option>
    </select>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "FilterStatus",
  methods: {
    changeValueEvent(event) {
      this.$emit('update:modelValue', event.target.value)
    }
  }
})
</script>


<style scoped>

</style>